import { render, staticRenderFns } from "./RichMenuTable.vue?vue&type=template&id=73b11b3a&"
import script from "./RichMenuTable.vue?vue&type=script&lang=js&"
export * from "./RichMenuTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b11b3a')) {
      api.createRecord('73b11b3a', component.options)
    } else {
      api.reload('73b11b3a', component.options)
    }
    module.hot.accept("./RichMenuTable.vue?vue&type=template&id=73b11b3a&", function () {
      api.rerender('73b11b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/RichMenu/Components/RichMenuTable.vue"
export default component.exports